import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { JOURNEY_CARD, CARD_DECK_COLORS, CARD_DECK_RADIUS, CARD_DECK_SHADOWS } from './constants';
import { recordJourneyCardShown } from '../../hooks/useJourneyCardLastShown';

import rainbowHappyCloud from '../../../assets/icons/home-v2/rainbow-happy-cloud.svg';
import rainbowCardHappyStar from '../../../assets/icons/home-v2/rainbow-card-happy-star.svg';
import rainbowHeartDecor from '../../../assets/icons/home-v2/rainbow-heart-decor.svg';
import rainbowArch1 from '../../../assets/icons/home-v2/rainbow-arch-1.svg';
import rainbowArch2 from '../../../assets/icons/home-v2/rainbow-arch-2.svg';
import rainbowArch3 from '../../../assets/icons/home-v2/rainbow-arch-3.svg';
import rainbowArch4 from '../../../assets/icons/home-v2/rainbow-arch-4.svg';
import rainbowBall from '../../../assets/icons/home-v2/rainbow-ball.svg';
import rainbowPen from '../../../assets/icons/home-v2/rainbow-pen.svg';
import rainbowPuzzlePiece from '../../../assets/icons/home-v2/rainbow-puzzle-piece.svg';
import rainbowCube from '../../../assets/icons/home-v2/rainbow-cube.svg';
import rainbowMessageCloud from '../../../assets/icons/home-v2/rainbow-message-cloud.svg';
import rainbowStarDecor from '../../../assets/icons/home-v2/rainbow-star-decor.svg';
import rainbowHexagonDecor from '../../../assets/icons/home-v2/rainbow-hexagon-decor.svg';
import rainbowRoundDecor from '../../../assets/icons/home-v2/rainbow-round-decor.svg';
import rainbowSmallRoundDecor from '../../../assets/icons/home-v2/rainbow-small-round-decor.svg';

export default function JourneyCardDeckCard() {
  const navigate = useNavigate();

  useEffect(() => {
    recordJourneyCardShown();
  }, []);

  return (
    <div
      className={`flex flex-col w-full aspect-[382/462] overflow-hidden ${JOURNEY_CARD.padding} ${JOURNEY_CARD.gap}`}
      style={{
        background: JOURNEY_CARD.background,
        border: JOURNEY_CARD.border,
        borderRadius: `${CARD_DECK_RADIUS.card}px`,
        boxShadow: CARD_DECK_SHADOWS.card,
      }}
    >
      {/* Illustration area */}
      <div
        className="relative w-full min-h-0 flex-1"
        style={{ borderRadius: `${JOURNEY_CARD.illustration.borderRadius}px` }}
      >
        {/* Center cloud group */}
        <img src={rainbowHappyCloud} alt="" aria-hidden="true" className="absolute"
          style={{ left: '22.3%', top: '45.9%', width: '50.7%' }} />
        <img src={rainbowCardHappyStar} alt="" aria-hidden="true" className="absolute"
          style={{ left: '66.5%', top: '72.5%', width: '14.6%' }} />
        <img src={rainbowHeartDecor} alt="" aria-hidden="true" className="absolute"
          style={{ left: '72.2%', top: '61.7%', width: '5.7%' }} />

        {/* Arch segments */}
        <img src={rainbowArch1} alt="" aria-hidden="true" className="absolute"
          style={{ left: '11.1%', top: '42.8%', width: '6.1%' }} />
        <img src={rainbowArch2} alt="" aria-hidden="true" className="absolute"
          style={{ left: '27.9%', top: '14.2%', width: '16.6%' }} />
        <img src={rainbowArch3} alt="" aria-hidden="true" className="absolute"
          style={{ left: '62.8%', top: '14.4%', width: '16.2%' }} />
        <img src={rainbowArch4} alt="" aria-hidden="true" className="absolute"
          style={{ left: '87.3%', top: '38.2%', width: '8.1%' }} />

        {/* Floating icons along arc */}
        <img src={rainbowPuzzlePiece} alt="" aria-hidden="true" className="absolute"
          style={{ left: '48.8%', top: '5.8%', width: '9.1%' }} />
        <img src={rainbowBall} alt="" aria-hidden="true" className="absolute"
          style={{ left: '18.1%', top: '26.4%', width: '8.1%' }} />
        <img src={rainbowPen} alt="" aria-hidden="true" className="absolute"
          style={{ left: '79.3%', top: '23.9%', width: '9.8%' }} />
        <img src={rainbowCube} alt="" aria-hidden="true" className="absolute"
          style={{ left: '6.4%', top: '72.5%', width: '7.8%' }} />
        <img src={rainbowMessageCloud} alt="" aria-hidden="true" className="absolute"
          style={{ left: '91.3%', top: '73.2%', width: '8.8%' }} />

        {/* Scattered decorations */}
        <img src={rainbowStarDecor} alt="" aria-hidden="true" className="absolute"
          style={{ left: '33.9%', top: '32.7%', width: '6.1%' }} />
        <img src={rainbowStarDecor} alt="" aria-hidden="true" className="absolute"
          style={{ left: '89.1%', top: '0.5%', width: '4.7%' }} />
        <img src={rainbowHexagonDecor} alt="" aria-hidden="true" className="absolute"
          style={{ left: '85.2%', top: '15.9%', width: '1.4%' }} />
        <img src={rainbowHexagonDecor} alt="" aria-hidden="true" className="absolute"
          style={{ left: '87.2%', top: '93.3%', width: '1.4%' }} />
        <img src={rainbowHexagonDecor} alt="" aria-hidden="true" className="absolute"
          style={{ left: '27.1%', top: '9.9%', width: '1.4%' }} />
        <img src={rainbowRoundDecor} alt="" aria-hidden="true" className="absolute"
          style={{ left: '13.2%', top: '16.9%', width: '3.4%' }} />
        <img src={rainbowSmallRoundDecor} alt="" aria-hidden="true" className="absolute"
          style={{ left: '6.7%', top: '7.8%', width: '1.7%' }} />
        <img src={rainbowSmallRoundDecor} alt="" aria-hidden="true" className="absolute"
          style={{ left: '0%', top: '52.9%', width: '1.7%' }} />
        <img src={rainbowRoundDecor} alt="" aria-hidden="true" className="absolute"
          style={{ left: '10.1%', top: '0%', width: '3.4%' }} />
        <img src={rainbowRoundDecor} alt="" aria-hidden="true" className="absolute"
          style={{ left: '94.3%', top: '14.9%', width: '4.4%' }} />
      </div>

      {/* Title */}
      <p
        className={`${JOURNEY_CARD.typography.title} text-center w-full shrink-0 mt-1`}
        style={{ color: JOURNEY_CARD.textColor, fontVariationSettings: "'opsz' 14" }}
      >
        Sparks that grow as they grow
      </p>

      {/* Subtitle */}
      <p
        className={`${JOURNEY_CARD.typography.subtitle} text-center w-full shrink-0`}
        style={{ color: JOURNEY_CARD.textColor, fontVariationSettings: "'opsz' 14" }}
      >
        Your little one is already learning every day. Tell us a bit about them and we'll shape the Sparks to match, and grow with them.
      </p>

      {/* CTA Button */}
      <button
        type="button"
        onClick={() => navigate('/journey')}
        className={`w-full shrink-0 flex items-center justify-center ${JOURNEY_CARD.button.heightClasses}`}
        style={{
          borderRadius: `${CARD_DECK_RADIUS.card / 2}px`,
          background: CARD_DECK_COLORS.buttonBackground,
          overflow: 'hidden',
        }}
      >
        <span
          className="text-white font-black whitespace-nowrap"
          style={{
            fontSize: '12px',
            letterSpacing: JOURNEY_CARD.button.letterSpacing,
            textTransform: 'uppercase',
            fontVariationSettings: "'opsz' 14",
          }}
        >
          {JOURNEY_CARD.button.label}
        </span>
      </button>
    </div>
  );
}
